<template>
	<tr v-if="partial_payment">
		<loading :active="loading">
			<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
		</loading>
		<td>
			<template v-if="edit_mode">
				<div class="form-group" :class="{ 'has-error' : errors.has('amount') }">
					<input
						v-validate="'required'"
						name="amount"
						data-vv-as="Importe"
						v-model="partial_payment.amount"
						type="number"
						class="form-control">
						<small v-show="errors.has('amount')" class="form-text text-danger">
							{{ errors.first('amount') }}
						</small>
				</div>
			</template>
			<template v-else>
				{{ partial_payment.amount }}
			</template>
		</td>
		<td>
			<template v-if="edit_mode">
				<div class="form-group" :class="{ 'has-error' : errors.has('payment_method') }">
					<select
						v-validate="'required'"
						name="payment_method"
						data-vv-as="Método de pago"
						v-model="partial_payment.payment_method_id"
						class="form-control">
						<template v-if="payment_methods">
							<template v-if="payment_methods.length">
								<option v-for="method in payment_methods" :value="method.id">
									{{ method.name }}
								</option>
							</template>
						</template>
					</select>
					<small v-show="errors.has('payment_method')" class="form-text text-danger">
						{{ errors.first('payment_method') }}
					</small>
				</div>
			</template>
			<template v-else>
				<template v-if="partial_payment.payment_method">
					{{ partial_payment.payment_method.name }}
				</template>
			</template>
		</td>
		<td>
			<div class="btn-group pull-right">
				<button v-if="!edit_mode" :class="{ 'disabled' : displayEdit }" @click="edit_mode = true" type="button" class="btn btn-info">
					<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
				</button>
				<button v-if="!edit_mode" :class="{ 'disabled' : displayEdit }" @click="destroy()" type="button" class="btn btn-danger">
					<i class="fa fa-trash" aria-hidden="true"></i>
				</button>
				<template v-if="edit_mode">
					<button :disabled="pending_payment < 0" @click="validate" type="button" class="btn btn-success">
						<i class="fa fa-floppy-o" aria-hidden="true"></i>
					</button>
					<button @click="close" type="button" class="btn btn-default">
						<i class="fa fa-times" aria-hidden="true"></i>
					</button>
				</template>
			</div>
		</td>
	</tr>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'order', 'invoice', 'partial', 'payment_methods', 'displayEdit', 'pending_payment'],
		components: {
			'loading': VueElementLoading,
		},
		created() {
			this.partial_payment = null
			if(this.partial) {
				this.partial_payment = Object.assign({}, this.partial)
			}
			if(this.order) {
				this.currency = this.order.currency
			}
			if(this.invoice) {
				this.currency = this.invoice.currency
			}
		},
		data () {
			return {
				loading: false,
				partial_payment: null,
				edit_mode: false,
				currency: null,
			}
		},
		watch: {
			partial() {
				this.partial_payment = null
				if(this.partial) {
					this.partial_payment = Object.assign({}, this.partial)
				}
			},
			'partial_payment.amount'() {
				this.partial_payment.amount = this.$options.filters.checkDecimals(this.partial_payment.amount)
				this.$emit('calculate', this.partial_payment)
			},
			edit_mode() {
				if(this.edit_mode) {
					this.$emit('editModeOn')
				} else {
					this.$emit('editModeOff')
				}
			},
		},
		methods: {
			close() {
				this.clearData()
				this.edit_mode = false
				this.$emit('editModeoff')
			},
			clearData() {
				this.errors.clear()
				this.partial_payment = null
				if(this.partial) {
					this.partial_payment = Object.assign({}, this.partial)
				}
			},
			destroy() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/partial/payments/' + that.partial_payment.id)
							.then(response => {
								that.$emit('reload')
								that.$emit('calculate')
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								})
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			validate() {
				var that = this
				if(this.pending_payment < 0) {
					return false
				}
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			update() {
				this.loading = true
				this.$http.put('admin/management/partial/payments/' + this.partial_payment.id, this.partial_payment)
				.then(response => {
					this.$emit('reload')
					this.edit_mode = false
					this.$emit('editModeoff')
					this.loading = false
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/partialPayments/views/Edit.vue